




import { defineComponent, watch, computed } from '@vue/composition-api';
import { useStore } from '@/store';
import BootstrapModal from '@/components/UI/BootstrapModal.vue';
import { MutationTypes } from '@/store/mutations';

export default defineComponent({
    name: 'IframeModal',
    components: { BootstrapModal },
    setup (props, { refs, root }) {
        const store = useStore();
        const src = computed(() => store.state.modal.src);
        const id = computed(() => store.state.modal.id);
        const open = computed(() => store.state.modal.isOpened);

        watch(open, (value) => {
            if (value) {
                root.$nextTick(() => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    $(refs.modal.$el).showModalWithIFrame(src.value)
                        .setupModal({ iframe: true, show: true });
                });
            }
        });

        const close = () => {
            store.commit(MutationTypes.CloseModal);
        };

        return { id, close };
    }
});
